var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLocationPin = function SvgLocationPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M15.049 15h2.509a2 2 0 0 1 1.897 1.368l.667 2A2 2 0 0 1 18.225 21H5.775a2 2 0 0 1-1.897-2.632l.667-2A2 2 0 0 1 6.442 15h2.51"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M12 18s-6-4.792-6-9.167C6 5.612 8.686 3 12 3s6 2.612 6 5.833C18 13.208 12 18 12 18",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M13.414 7.586a2 2 0 1 1-2.828 2.828 2 2 0 0 1 2.828-2.828"
  })));
};
export default SvgLocationPin;